import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch } from 'react-router-dom';
import { DcSurvey } from './Surveys/DcSurvey';
import { DbSurvey } from './Surveys/DbSurvey';
import { PabsSurvey } from './Surveys/PabsSurvey';
import { HelpHelper } from './Help/HelpHelper';
import registerServiceWorker from './registerServiceWorker';
import 'antd/dist/antd.css';
import './Styling/custom.css';
import 'react-tippy/dist/tippy.css';
import '@progress/kendo-theme-material/dist/all.css';
import { Route } from 'react-router-dom';
import { Logout } from './components/AuthComponents/logout';
import { LogoutCallback } from './components/AuthComponents/logoutCallback';
import { Callback } from './components/AuthComponents/callback';
import { SilentRenew } from './components/AuthComponents/silentRenew';
import { SignInRedirect } from './components/AuthComponents/signinRedirect';
import { AuthProvider } from './Providers/AuthProvider';
import { observer } from 'mobx-react';
import { BenchmarkNLSurvey } from './Surveys/BenchmarkNLSurvey';
import { PabsUkSurvey } from './Surveys/PabsUkSurvey';
import { PabsLgSurvey } from './Surveys/PabsLgSurvey';
import { IBSHomePage } from './components/IBSHomePage';
import RegisterAllLocalesForNumeralJs from "./locales/all";
import { SurveyAccessPage } from './PageComponents/SurveyAccessPage';
import PrivateRoute from './Routing/PrivateRoute';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const service = window.location.pathname.split('/')[1];
const rootElement = document.getElementById('root');

RegisterAllLocalesForNumeralJs();

const LoadPage = observer(() => {
    return (
        <div>
            <Route exact={true} path='/signin-oidc-callback' component={Callback} />
            <Route exact={true} path='/ibs/signin' component={SignInRedirect} />
            <Route exact={true} path='/pabs/signin' component={SignInRedirect} />
            <Route exact={true} path='/logout' component={Logout} />
            <Route exact={true} path='/logout/callback' component={LogoutCallback} />
            <Route exact={true} path='/silentrenew' component={SilentRenew} />
            <Route exact={true} path='/' component={SurveyAccessPage} />

            <PrivateRoute exact={true} path='/ibs/laundromat' component={IBSHomePage} />
            <PrivateRoute
                exact={true}
                path='/ibs/recentActivities'
                component={IBSHomePage}
            />
            <PrivateRoute exact={true} path='/ibs/home' component={IBSHomePage} allowClientAccess />
            <PrivateRoute path='/db' component={DbSurvey} allowClientAccess />
            <PrivateRoute path='/dc' component={DcSurvey} allowClientAccess />
            <PrivateRoute path='/pabs' component={PabsSurvey} allowClientAccess />
            <PrivateRoute path='/pabsuk' component={PabsUkSurvey} allowClientAccess />
            <PrivateRoute path='/pabslg' component={PabsLgSurvey} allowClientAccess />
            <PrivateRoute path='/benchmarknl' component={BenchmarkNLSurvey} allowClientAccess />
            <PrivateRoute path='/help' component={HelpHelper} allowClientAccess />
        </div>
    );
});

ReactDOM.render(
    <React.Fragment>
        <AuthProvider service={service}>
            <BrowserRouter basename={baseUrl}>
                <LoadPage />
            </BrowserRouter>
        </AuthProvider>
    </React.Fragment>,
    rootElement
);

registerServiceWorker();
